import React from 'react';
import { Helmet } from 'react-helmet-async';

const StructuredData = () => {
	const jsonLd = {
		"@context": "https://schema.org",
		"@type": "LocalBusiness",
		"name": "Room 49",
		"url": "https://thetypingrooms.co.uk",
		"image": "https://thetypingrooms.co.uk/images/room49-og-image.jpg",
		"description": "A self-service shared office space in St John's, Tunbridge Wells. Drop in for the day or book monthly—calm, comfortable, and built for getting work done.",
		"address": {
			"@type": "PostalAddress",
			"streetAddress": "49 St John's Road",
			"addressLocality": "Tunbridge Wells",
			"postalCode": "TN4 9TP",
			"addressCountry": "UK"
		},
		"openingHoursSpecification": [
			{
				"@type": "OpeningHoursSpecification",
				"dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
				"opens": "09:00",
				"closes": "19:00"
			}
		]
	};

	return (
		<Helmet>
			<script type="application/ld+json">
				{JSON.stringify(jsonLd)}
			</script>
		</Helmet>
	);
};

export default StructuredData;
